
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Constituency } from '@/types/geography';

export const useConstituencyFetching = () => {
  const [availableConstituencies, setAvailableConstituencies] = useState<Constituency[]>([]);

  const fetchConstituencies = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('active_constituencies')
        .select('*')
        .order('constituency_name');

      if (error) throw error;
      
      // Map the data to match our Constituency type
      const mappedConstituencies: Constituency[] = (data || []).map(item => ({
        id: item.id,
        name: item.constituency_name,
        code: item.constituency_code,
        constituency_name: item.constituency_name,
        constituency_code: item.constituency_code,
        country_code: item.country_code,
        active: item.active,
        created_at: item.created_at,
        updated_at: item.updated_at
      }));
      
      setAvailableConstituencies(mappedConstituencies);
      return mappedConstituencies;
    } catch (error) {
      console.error("Error fetching constituencies:", error);
      setAvailableConstituencies([]);
      return [];
    }
  }, []);

  useEffect(() => {
    fetchConstituencies();
  }, [fetchConstituencies]);

  return { availableConstituencies, fetchConstituencies };
};
